// TopVendorsApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'TopVendors'];

// Enhance the base API service by adding entication-related tag types
const TopVendorsApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
        
      // Fetch TopVendors query (GET request to /me)
      getTopVendors: build.query({
        query: () => ({
          url: `/TopVendors`,
        }),
        providesTags: ['TopVendors'],
      }),  
     
       
    }),
    overrideExisting: false,
  });

export default TopVendorsApi;

// Exporting hooks for each endpoint to be used in components
export const {
     useGetTopVendorsQuery,
 } = TopVendorsApi;


